var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnthropic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.445 37.468H8.57l3.125-7.767H26.96l3.124 7.767h7.946L23.3.688h-8.482L.445 37.468zm13.93-14.662l4.91-12.587 4.91 12.587h-9.82z",
    fill: "var(--joy-palette-text-primary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.46.688h-8.124L45.709 37.29h8.302L39.46.688z",
    fill: "var(--joy-palette-text-primary)"
  })));
}
export default SvgAnthropic;